































import {
    Component,
    ComponentStyle,
    ComponentStyleDefinition,
    Inject,
    InjectComponent,
    Mixins,
    Prop,
    RangeQuestion,
    VueComponent
} from "@zoovu/runner-browser-api";
import QuestionBaseMixin from "./question-base.vue";
import {formatNumberForRangeAndSliderQuestionTypes} from "./utils"

@Component({})
export default class RangeQuestionView extends Mixins(QuestionBaseMixin) {
    @Inject() readonly localizationSettings!: LocalizationSettings;

    @Prop()
    question: RangeQuestion;

    @Prop({default: false})
    isFilterQuestion: boolean;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("Slider")
    slider: VueComponent;

    @InjectComponent("QuestionValidationMessageView")
    questionValidationMessageView: VueComponent;

    @InjectComponent("QuestionHeadView")
    questionHeadView: VueComponent;

    leftSliderValue = null;
    rightSliderValue = null;

    formatPrice(value: number) {
      return formatNumberForRangeAndSliderQuestionTypes(value, this.question.unit ?? this.localizationSettings?.currencyCode, this.localizationSettings?.locale);
    }

    get leftQuestionValue() {
        const left = this.question.lowerBoundaryValue;
        return left === null || typeof left === "undefined" ? this.question.defaultLowerBoundaryValue : left;
    }

    get rightQuestionValue() {
        const right = this.question.upperBoundaryValue;

        return right === null || typeof right === "undefined" ? this.question.defaultUpperBoundaryValue : right;
    }

    get displayedLeftValue() {
        return this.leftSliderValue !== null ? this.leftSliderValue : this.leftQuestionValue;
    }

    get displayedRightValue() {
        return this.rightSliderValue !== null ? this.rightSliderValue : this.rightQuestionValue;
    }

     get filterClass() {
        return {
            "filter-slider-box": this.isFilterQuestion,
        };
    }

    onLeftValueChange(left) {
        this.leftSliderValue = left;
    }

    onRightValueChange(right) {
        this.rightSliderValue = right;
    }

    onLeftValueChanged(left: number) {
        if (left !== this.question.lowerBoundaryValue) {
            this.question.setLowerBoundaryValue(left);
        }
    }

    onRightValueChanged(right: number) {
        if (right !== this.question.upperBoundaryValue) {
            this.question.setUpperBoundaryValue(right);
        }
    }

    beforeMount(): void {
        if (!this.isFilterQuestion && !this.question.isMandatory && this.question.isUnanswered) {
            this.question.setLowerBoundaryValue(this.question.defaultLowerBoundaryValue);
            this.question.setUpperBoundaryValue(this.question.defaultUpperBoundaryValue);
        }
    }
}
